// extracted by mini-css-extract-plugin
export var columns_2 = "Grid-module--columns_2--d8b4a";
export var columns_2_3 = "Grid-module--columns_2_3--e8412";
export var columns_3 = "Grid-module--columns_3--945f5";
export var columns_4 = "Grid-module--columns_4--8787b";
export var grid = "Grid-module--grid--63890";
export var list = "Grid-module--list--3c2eb";